<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     商城管理-商品列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="em-product padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="status" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <el-cascader
            v-model="query.catid"
            placeholder="选择商品类目"
            :options="options"
            :props="{ expandTrigger: 'click', checkStrictly: true }"
            filterable
            clearable
            @change="changeProductType"
          ></el-cascader>
        </div>
        <div class="filter-item" style="width: 260px;">
          <div class="flex-center">
            <el-input v-model="query.min_price" placeholder="￥最小价格" clearable @change="fetchData()" />
            <span class="ml-xs mr-xs text-muted">—</span>
            <el-input v-model="query.max_price" placeholder="￥最大价格" clearable @change="fetchData()" />
          </div>
        </div>
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.title" placeholder="商品名称" prefix-icon="el-icon-search" clearable @change="fetchData()" />
        </div>
      </div>
      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="categoryShow = true">新建商品</el-button>
        <el-button icon="el-icon-truck" type="success" plain @click="shippingTemplateShow = true">运费模板</el-button>
        <el-button icon="el-icon-setting" type="success" plain class="mr-sm" @click="setShow = true">橱窗设置</el-button>
        <div class="mode bg-white radius5 flex align-items-center">
          <i class="iconfont icon-list-mode text-muted" :class="{ 'text-primary': product_mode == 'list'}" role="button" @click="setMode('list')"></i>
          <i
            class="iconfont icon-card-mode text-muted ml-sm"
            :class="{ 'text-primary': product_mode == 'card'}"
            role="button"
            @click="setMode('card')"
          ></i>
        </div>
      </div>
    </div>

    <el-card v-if="product_mode == 'list'" v-loading="loading" shadow="never" class="mb-md">
      <el-table ref="listTable" :data="list" tooltip-effect="dark" class="padding-small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" :selectable="selectable" width="50"  />
        <el-table-column width="42" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.godid == godid" class="font-lg" role="button" @click="stickHandle(scope.row)">
              <el-tooltip effect="dark" :content="scope.row.displayorder > 0 ? '取消置顶' : '置顶'" placement="top">
                <i v-if="scope.row.displayorder > 0" class="iconfont icon-pin-b text-yellow"></i>
                <i v-else class="iconfont icon-pin hover-show text-muted"></i>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="60">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.first_head_img" />
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="160">
          <div slot-scope="scope" class="flex align-items-center">
            <div v-if="scope.row.showcase_enable" class="mr-sm tag" style="flex-shrink: 0;">橱窗</div>
            <el-popover
              v-if="scope.row.distribution_enable"
              placement="bottom-start"
              :width="430"
              trigger="hover"
              popper-class="commission-pop"
              :visible-arrow="false"
            >
              <div class="commission">
                <div class="mb-xs text-black">带货商品由鱼漾智能负责发货、售后工作。</div>

                <div class="mb text-black">带货商品每售出 1 件商品，您将获得下列佣金：</div>

                <el-table :data="scope.row.skus" style="width: 100%;">
                  <el-table-column label="规格" prop="type" min-width="120" show-overflow-tooltip>
                    <template v-if="scope.row.attrs && scope.row.attrs.length" slot-scope="scope">
                      <span v-for="(attr, i) in scope.row.attrs" :key="i" class="mr-xs">{{ attr.attr_value }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="售价" prop="price" min-width="100">
                    <template slot-scope="scope">
                      <span>￥{{ scope.row.sale_price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="佣金" prop="commission" min-width="100">
                    <template slot-scope="scope">
                      <span class="text-primary">赚￥{{ scope.row.commission }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div slot="reference" class="text-primary">
                <div v-if="scope.row.distribution_enable" class="mr-sm tag distribution" style="flex-shrink: 0;">带货</div>
              </div>
            </el-popover>
            <el-link v-if="scope.row.edit_status != 2" v-overflow-tooltip="1" class="ellipsis flex1" style="display:block;" :underline="false" @click="toProductDetail(scope.row)">{{ scope.row.title }}</el-link>
            <span v-else v-overflow-tooltip="1" class="ellipsis" style="display:block;max-width: 170px;">{{ scope.row.title }}</span>
          </div>
        </el-table-column>

        <el-table-column label="价格" min-width="100">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <span>{{ scope.row.sale_price | currency }}</span>
              <TierPricingDisplay v-if="scope.row.advanced_prices.length" :advanced_prices="scope.row.advanced_prices" />
              <ProductOnlineDoc v-if="scope.row.resources.length" :resources="scope.row.resources" />
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="isGodid1" label="库存" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.godid == godid">{{ scope.row.stock_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销量" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.godid == godid">{{ scope.row.total_sold_num }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="更新时间">
          <template slot-scope="scope">
            <span>{{ scope.row.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 5" type="success">{{ '已上架' }}</el-tag>
            <el-tag v-else-if="scope.row.status == 0" type="warning">{{ '待上架' }}</el-tag>
            <el-tag v-else-if="scope.row.status == 11" type="danger">{{ '手动下架' }}</el-tag>
            <el-tooltip v-else-if="scope.row.status == 13" effect="dark" content="请联系客服处理" placement="top">
              <el-tag type="danger">{{ '违规下架' }}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column width="200" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 13" type="text">
              <el-popover
                v-model="scope.row.qrPopoverVisible"
                placement="left"
                :ref="'qrPopover' + scope.row.productid"
                :width="200"
                trigger="click"
                popper-class="qr-pop"
                :visible-arrow="false"
                @show="handleQrPopoverShow(scope.row)"
              >
                <div class="qr-code flex column align-items-center">
                  <div class="mb-sm" style="font-size: 16px;">请使用微信扫码预览</div>
                  <div v-if="!scope.row.imageUrl" v-loading="scope.row.qrLoading" style="width: 150px;height: 150px;"></div>
                  <img v-else :src="scope.row.imageUrl" alt style="width: 150px;height: 150px;" />
                </div>
                <div slot="reference" @click.stop="toggleQrPopover(scope.row)">
                  预览
                </div>
              </el-popover>
            </el-button>
            <el-button v-if="!scope.row.showcase_enable && scope.row.godid == godid && scope.row.status !== 13" type="text" style="margin-left: 5px;" @click="handleShowcase(scope.row, 1)">加入橱窗</el-button>
            <el-button v-if="scope.row.showcase_enable && scope.row.godid == godid && scope.row.status !== 13" type="text" style="margin-left: 5px;" @click="handleShowcase(scope.row, 0)">移出橱窗</el-button>
            <el-button
              v-if="scope.row.status !== 5 && scope.row.edit_status !== 2 && scope.row.status !== 13 && scope.row.godid == godid"
              type="text"
              style="margin-left: 5px;"
              @click="putOnShelf(scope.row)"
            >上架</el-button>
            <el-button v-if="scope.row.edit_status == 2 && scope.row.godid == godid" type="text" style="margin-left: 5px;" @click="resetReview(scope.row)">撤销审核</el-button>
            <el-button
              v-if="scope.row.status == 5 && scope.row.edit_status != 2 && scope.row.godid == godid"
              type="text"
              style="margin-left: 5px;"
              @click="offShelf(scope.row)"
            >下架</el-button>
            <el-button v-if="scope.row.godid == godid" type="text" :class="{ 'ml-xs': scope.row.status !== 13 }" @click="delProduct(scope.row)">删除</el-button>
            <el-button v-if="scope.row.godid != godid && scope.row.distribution_enable" type="text" style="margin-left: 5px;" @click="removeProduct(scope.row)">移除商品</el-button>
          </template>
        </el-table-column>
        <template slot="append"></template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>

    <div v-else class="flex" style="flex-wrap: wrap;justify-content: flex-start;">
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="index" role="button" class="bg-white radius10 mb-md mr-md product-card">
          <div class="product-option">
            <div v-if="item.godid == godid" class="font-lg stick" role="button" @click.stop="stickHandle(item)">
              <el-tooltip effect="dark" :content="item.displayorder > 0 ? '取消置顶' : '置顶'" placement="top" class="font-lg">
                <i v-if="item.displayorder > 0" class="iconfont icon-pin-b text-yellow"></i>
                <i v-else class="iconfont icon-pin text-muted"></i>
              </el-tooltip>
            </div>
          <el-popover placement="bottom-end" width="100" trigger="click" popper-class="tool-pop-ei" :visible-arrow="false">
            <div
              v-if="item.showcase_enable && item.godid == godid && item.status !== 13"
              class="pop-item pops"
              role="button"
              @click="handleShowcase(item, 0)"
            >移出橱窗</div>
            <div
              v-if="!item.showcase_enable && item.godid == godid && item.status !== 13"
              class="pop-item pops"
              role="button"
              @click="handleShowcase(item, 1)"
            >加入橱窗</div>
            <div
              v-if="item.status !== 5 && item.edit_status !== 2 && item.status !== 13 && item.godid == godid"
              class="pop-item pops"
              role="button"
              @click="putOnShelf(item)"
            >上架</div>
            <div
              v-if="item.status == 5 && item.edit_status != 2 && item.godid == godid"
              class="pop-item pops"
              role="button"
              @click="offShelf(item)"
            >下架</div>
            <div v-if="item.edit_status == 2 && item.godid == godid" class="pop-item pops" role="button" @click="resetReview(item)">撤销审核</div>
            <div v-if="item.godid == godid" class="pop-item pops" role="button" @click="delProduct(item)">删除</div>
            <div v-if="item.godid != godid && item.distribution_enable" class="pop-item pops" role="button" @click="removeProduct(item)">移除商品</div>
            <i class="el-icon-more font-lg text-muted more" slot="reference" role="button"></i>
          </el-popover>
          </div>

          <el-image :src="item.first_head_img" fit="cover" class="product-img" @click="toProductDetail(item)" />
          <div class="flex column pt-sm pb-sm pl-sm pr-sm" @click="toProductDetail(item)">
            <div class="product-title flex">
              <div v-if="item.showcase_enable" class="mr-sm tag_card">橱窗</div>
              <el-popover
                v-if="item.distribution_enable"
                placement="bottom-start"
                :width="430"
                trigger="hover"
                popper-class="commission-pop1"
                :open-delay="200"
                :visible-arrow="false"
              >
                <div class="commission">
                  <div class="mb-xs text-black">带货商品由鱼漾智能负责发货、售后工作。</div>
                  <div class="mb text-black">带货商品每售出 1 件商品，您将获得下列佣金：</div>

                  <el-table :data="item.skus" style="width: 100%;">
                    <el-table-column label="规格" prop="type" min-width="120" show-overflow-tooltip>
                      <template v-if="scope.row.attrs && scope.row.attrs.length" slot-scope="scope">
                        <span v-for="(attr, i) in scope.row.attrs" :key="i" class="mr-xs">{{ attr.attr_value }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="售价" prop="price" min-width="100">
                      <template slot-scope="scope">
                        <span>￥{{ scope.row.sale_price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="佣金" prop="commission" min-width="100">
                      <template slot-scope="scope">
                        <span class="text-primary">赚￥{{ scope.row.commission }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div slot="reference" class="text-primary">
                  <div v-if="item.distribution_enable" class="mr-sm tag_card distribution">带货</div>
                </div>
              </el-popover>
              <div
                class="title-text"
                :class="(item.distribution_enable && item.showcase_enable) ?
                        'indent2' :
                        (item.distribution_enable || item.showcase_enable) ?
                        'indent' : ''"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="mt-sm flex align-items-center">
              <div class="bd flex align-items-center">
                <div class="text-warning font-lg">{{ item.sale_price | currency }}</div>
                <TierPricingDisplay v-if="item.advanced_prices.length" style="margin-top: 4px;" :advanced_prices="item.advanced_prices" />
                <ProductOnlineDoc v-if="item.resources.length" style="margin-top: 4px;" :resources="item.resources" />
              </div>
              <el-popover
                v-model="item.qrPopoverVisible"
                placement="top-end"
                :ref="'qrPopover' + item.productid"
                :width="200"
                trigger="hover"
                popper-class="qr-pop"
                :visible-arrow="false"
                class="ft"
                @show="handleQrPopoverShow(item)"
              >
                <div class="qr-code flex column align-items-center">
                  <div class="mb-sm" style="font-size: 16px;">请使用微信扫码预览</div>
                  <div v-if="!item.imageUrl" v-loading="item.qrLoading" style="width: 150px;height: 150px;"></div>
                  <img v-else :src="item.imageUrl" alt style="width: 150px;height: 150px;" />
                </div>
                <div slot="reference" style="font-size: 24px;height: 28px;line-height: 28px;">
                  <i class="iconfont icon-qr"></i>
                </div>
              </el-popover>
            </div>

            <div class="flex align-items-center justify-content-space-between mt-sm">
              <el-popover
                v-if="item.distribution_enable"
                placement="bottom-start"
                :width="430"
                trigger="hover"
                popper-class="commission-pop"
                :visible-arrow="false"
              >
                <div class="commission">
                  <div class="mb-xs text-black">带货商品由鱼漾智能负责发货、售后工作。</div>

                  <div class="mb text-black">带货商品每售出 1 件商品，您将获得下列佣金：</div>

                  <el-table :data="item.skus" style="width: 100%;">
                    <el-table-column label="规格" prop="type" min-width="120" show-overflow-tooltip>
                      <template v-if="scope.row.attrs && scope.row.attrs.length" slot-scope="scope">
                        <span v-for="(attr, i) in scope.row.attrs" :key="i" class="mr-xs">{{ attr.attr_value }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="售价" prop="price" min-width="100">
                      <template slot-scope="scope">
                        <span>￥{{ scope.row.sale_price }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="佣金" prop="commission" min-width="100">
                      <template slot-scope="scope">
                        <span class="text-primary">赚￥{{ scope.row.commission }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div slot="reference" class="text-primary">
                  佣金
                  <span>￥{{ item.skus[0].commission }}</span>
                </div>
              </el-popover>
              <div class v-if="item.godid == godid">销量 {{ item.total_sold_num }}</div>
              <div class v-if="isGodid1 && item.godid == godid">库存 {{ item.stock_num }}</div>
            </div>
          </div>
          <div v-if="(item.status !== 5 && item.edit_status !== 2)" @click="toProductDetail(item)" class="mask flex-center column radius10">
            <div class="removed flex-center text-white font-md text-bold">已下架</div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="product_mode == 'card' && !list.length" class="flex-center column pb-md mt-hg">
      <div class="flex-center mt-hg">
        <img src="../../assets/no-data.png" alt class="no-data" />
      </div>
    </div>

    <f-table-footer
      v-if="list.length"
      :list="list"
      :selection="multiSelection"
      :checkbox="product_mode == 'list' ? true : false"
      @toggle="toggleAll"
      class="main-footer-fix"
      style="padding-left: 38px"
    >
      <el-button
        v-if="product_mode == 'list'"
        type="primary"
        size="mini"
        :disabled="multiSelection.length === 0"
        :plain="multiSelection.length === 0"
        @click="multiDelProduct"
      >批量删除</el-button>
      <template slot="right">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" :sizes-show="product_mode == 'list'" @change="fetchData" />
      </template>
    </f-table-footer>

    <product-category v-if="categoryShow" :show.sync="categoryShow" @change="newProduct" />

    <mall-set v-if="setShow" :show.sync="setShow" />

    <shipping-template v-if="shippingTemplateShow" :show.sync="shippingTemplateShow" />
  </div>
</template>

<script>
import {
  getGodProductCategoryApi,
  getMallProductListApi,
  putOnShelfApi,
  putOffShelfApi,
  delProductApi,
  resetProductReviewApi,
  stickProductAPi,
  unstickProductAPi,
  productRemove,
  postShowcaseApi,
} from "@/api/ei/eiMallApi";
import { getQrcodeApi } from "@/api/ei/eiApi";
import ProductOnlineDoc from "./components/ProductOnlineDoc.vue";

export default {
  name: "EmProduct",

  components: {
    ProductCategory: () => import("./components/ProductCategory"),
    MallSet: () => import("./components/MallSet.vue"),
    ShippingTemplate: () => import("./components/ShippingTemplateDialog"),
    TierPricingDisplay: () => import("./components/TierPricingDisplay.vue"),
    ProductOnlineDoc,
  },

  data() {
    return {
      setShow: false,
      itemRow: {},
      categoryShow: false,
      loading: false,
      options: [],
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        title: "",
        status: 0,
        catid: null,
        min_price: null,
        max_price: null,
      },
      list: [],
      status: [
        { value: 0, title: "全部", separate: true },
        { value: 1, title: "橱窗" },
        { value: 2, title: "在售" },
        { value: 3, title: "已下架" },
      ],
      multiSelection: [],
      total: 0,
      product_mode: "",
      shippingTemplateShow: false,
    };
  },

  computed: {
    godid() {
      return this.$store.state.godStore.godid;
    },
    isGodid1() {
      return this.godid == 1;
    },
  },

  created: function () {
    const keepAlivePath = ["/em/product/detail"];
    this.query = this.$utils.initListQuery(this.query, keepAlivePath);
    this.product_mode = localStorage.getItem("__PRODECT_MODE__") || "card";

    this.fetchData();
    this.fetchCategory();
  },

  beforeRouteEnter(to, from, next) {
    next(function(vm) {
      if(from.path === '/em/shipping/template') {
        vm.shippingTemplateShow = true;
      }
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  methods: {
    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    selectable(row) {
      return row.godid == this.godid;
    },

    setMode(mode) {
      this.product_mode = mode;
      localStorage.setItem("__PRODECT_MODE__", mode);
      if(this.list.length) {
        this.list.forEach((product) => {
          product.qrPopoverVisible = false;
        });
      }
    },

    newProduct(catid) {
      this.$router.push({ path: "/em/product/detail?cat_id=" + catid });
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    changeProductType(e) {
      this.query.catid = e.length > 0 ? e[e.length - 1] : null;
      this.fetchData(1);
    },

    fetchCategory() {
      getGodProductCategoryApi().then((res) => {
        if (res.errno === 0) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchData(page) {
      if (this.product_mode == "card") this.query.psize = 12;
      if (page) this.query.pindex = page;
      this.loading = true;
      getMallProductListApi(this.query).then((res) => {
        this.loading = false;
        if (res.errno === 0) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    toProductDetail(row) {
      if (row.godid != this.godid) {
        // 弹出二维码如果弹出则执行关闭
        row.qrPopoverVisible = !row.qrPopoverVisible;
        return;
      }
      if (row.edit_status != 2)
        this.$router.push({
          path:
            "/em/product/detail?productid=" +
            row.productid +
            "&cat_id=" +
            row.catid,
        });
    },

    putOnShelf(item) {
      this.$confirm(
        `确定上架商品<span style="color:#07c160";> ${item.title}</span> ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          putOnShelfApi({ productid: item.productid }).then((res) => {
            if (!res.errno) {
              this.$message.success("商品已上架成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    offShelf(item) {
      this.$confirm(
        `确定下架商品<span style="color:#07c160";> ${item.title} </span>？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          putOffShelfApi({ productid: item.productid }).then((res) => {
            if (!res.errno) {
              this.$message.success("商品已下架成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    resetReview(item) {
      this.$confirm(
        `请确认是否撤销正在审核的商品<span style="color:#07c160";> ${item.title}</span>？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          resetProductReviewApi({ productid: item.productid }).then((res) => {
            if (!res.errno) {
              this.$message.success("撤销成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    delProduct(item) {
      this.$confirm(
        `请确认是否删除商品<span style="color:#07c160";> ${item.title}</span> ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          delProductApi({ productids: [item.productid] }).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("删除商品成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    removeProduct(item) {
      this.$confirm(
        `即将移除带货商品，移除后将放弃带货赚佣金的权益，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          productRemove({ productid: item.productid }).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("移除商品成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    multiDelProduct() {
      let tmp = this.multiSelection.map((v) => v.productid);
      this.$confirm(`请确认是否批量删除已选中商品？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          delProductApi({ productids: tmp }).then((res) => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("删除商品成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    stickHandle(row) {
      let { productid } = row;
      if (row.displayorder > 0) {
        unstickProductAPi({ productid }).then((res) => {
          if (!res.errno) {
            this.$message.success("取消置顶成功！");
            this.fetchData();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        stickProductAPi({ productid }).then((res) => {
          if (!res.errno) {
            this.$message.success("置顶成功！");
            this.fetchData();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    toggleQrPopover(row) {
      if (row.qrPopoverVisible) {
        this.$refs[`qrPopover${row.productid}`][0].doClose();
      } else {
        // 关闭其他所有打开的 popover
        this.list.forEach((product) => {
          if (product.productid !== row.productid) {
            product.qrPopoverVisible = false;
          }
        });
      }
    },
    handleQrPopoverShow(item) {
      // 关闭其他所有打开的 popover
      this.list.forEach((product) => {
        if (product.productid !== item.productid) {
          product.qrPopoverVisible = false;
        }
      });
      if (item.imageUrl) {
        return;
      }
      // 设置当前商品的二维码加载状态
      item.qrLoading = true;
      let index = this.list.findIndex(
        (product) => product.productid === item.productid
      );
      this.$set(this.list, index, item);
      // 获取二维码
      const param = {
        scene: `id=${item.productid}&godid=${this.godid}`,
        path: "pages/mall/detail",
      };
      getQrcodeApi(param).then((res) => {
        item.qrLoading = false;
        if (!res.errno) {
          const base64 = btoa(String.fromCharCode(...new Uint8Array(res)));
          const imgUrl = `data:image/png;base64,${base64}`;
          item.imageUrl = imgUrl;
          this.$set(this.list, index, item); // 更新列表中的商品信息
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleShowcase(item, status) {
      this.$confirm(
        `确认将商品<span style="color:#07c160";> ${item.title} </span> ${status == 0 ? "移出" : "加入"}橱窗，是否继续？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          postShowcaseApi({ productid: item.productid, showcase_enable: status }).then((res) => {
            if (!res.errno) {
              this.$message.success("操作成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    }
  },
};
</script>

<style lang="scss" scoped>
.pops {
  padding: 6px 15px;
}
.mode {
  height: 36px;
  padding: 10px 10px;
  .iconfont {
    font-size: 22px;
  }
}
.tag {
  height: 20px;
  line-height: 20px;
  border-radius: 5px;
  background-color: #07c160;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  padding: 0 10px;

  &.distribution {
    background-color: #409EFF;
  }
}
.product-card {
  width: 250px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  position: relative;
  .icon-qr {
    color: #999;
    &:hover {
      color: #07c160;
    }
  }
  &:hover {
    .hover-show {
      display: inline-block !important;
      transition: display 0.5s;
    }
    .product-option {
      display: block;
    }
  }

  .product-option {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 202;
    height: 30px;
    width: 100%;
    background-color: rgba(238, 240, 245, 0.5);

    .stick {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

    .more {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .product-img {
    width: 250px;
    height: 250px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .product-title {
    height: 40px;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    span:first-child {
      z-index: 9;
    }
    .tag_card {
      height: 20px;
      line-height: 20px;
      border-radius: 5px;
      background-color: #07c160;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      text-align: center;
      width: 40px;

      &.distribution {
        background-color: #409EFF;
      }
    }
    .title-text {
      flex: 1;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      &.indent {
        margin-left: -50px;
        text-indent: 50px;
      }
      &.indent2 {
        margin-left: -100px;
        text-indent: 100px;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(51, 51, 51, 0.6);
    z-index: 201;
    opacity: 1;
    transition: all 0.2s;
    .removed {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background-color: rgba(49, 49, 49, 0.9);
    }
  }
}
</style>

<style lang="scss">
.tool-pop-ei {
  padding: 5px 0 !important;
  .pop-item {
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
    }
  }
}
</style>
